module.exports = __webpack_public_path__ + "img/descarga_apple.b64b65c7.png";